<template>
  <div class="administration-nav">
    <div class="administration-logo">
      <img src="../../../assets/img/logo.svg" alt="KCM">
      <span>АДМИНИСТРАЦИЯ</span>
    </div>
    <div class="administration-links">
      <p>КАТЕГОРИИ НОВИНИ</p>
      <ul>
        <li>
          <router-link to="/administration?page=news&type=news">КЦМ Новини</router-link>
        </li>
        <li>
          <router-link to="/administration?page=news&type=media">Медиите за нас</router-link>
        </li>
        <li>
          <router-link to="/administration?page=news&type=gallery">Галерия</router-link>
          <router-link to="/administration?page=news&type=news-liferecad">Life Recad Новини</router-link>
        </li>
        <li>
          <router-link to="/administration?page=message">Съобщение</router-link>
        </li>
      </ul>
    </div>
    <!-- <a class="exit" @click="logout()">{{ $t('logout') }}</a> -->
  </div>
</template>

<script>
export default {
  methods: {
    validate() {
      const token = localStorage.getItem("token");
      this.$http
        .post(`${process.env.VUE_APP_BASE_URI}/auth/validate`, { token: token })
        .then(res => {
           /* eslint-disable-next-line */ 
          if (res.data.user) {
          } else {
            this.logout();
          }
        })
        .catch(err => {
          console.log(err);
          this.logout();
        });
    },
    logout() {
      this.$store
        .dispatch("logout")
        .then(() => this.$router.push("/administration/login"))

        .catch(err => console.log(err));
    }
  },
  mounted() {
    this.validate();
  }
};
</script>

<style lang="scss" scoped>
.administration-nav {
  align-items: center;
  background-color: #fff;
  background-image: url('../../../assets/img/administration/bg.jpg');
  background-position: 48% 0%;
  background-size: cover;
  display: flex;
  flex-direction: column;
  font-weight: 700;
  height: calc(100vh - 20px);
  justify-content: flex-start;
  left: 10px;
  position: fixed;
  top: 10px;
  text-transform: uppercase;
  width: 250px;
}
.administration-logo {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 15px 30px;
  width: 100%;
  img {
    display: block;
    height: auto;
    width: 100%;
  }
  span {
    color: #004785;
    font-size: 9px;
    font-weight: 500;
    letter-spacing: 3px;
    margin-top: 10px;
  }
}
.administration-links {
  border-top: 3px solid #d1d8de;
  padding-bottom: 14px;
  width: 100%;
  p {
    font-size: 9px;
    font-weight: 700;
    padding: 14px 23px;
  }
  li {
    width: 100%;
    a {
      cursor: pointer;
      display: block;
      font-size: 12px;
      font-weight: 400;
      padding: 14px 23px;
      text-transform: capitalize;
      @include transition(all 0.3s $mainCubic);
      width: 100%;
    }
    a:hover,
    .router-link-exact-active {
      background-color: $mainColor3;
      color: #fff;
    }
    .router-link-exact-active:hover {
      opacity: 0.9;
    }
  }
}

@media screen and (max-width: 1000px) {
  .administration-nav {
    display: none;
  }
}
</style>
